<script setup lang="ts">
  import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

  const route = useRoute()
  const btMobileApp = useCookie<string>('btMobileApp', { path: '/', domain: COOKIE_OPTIONS.domain })
  const hideHeader = computed(() => btMobileApp.value !== undefined)

  const loaderVisible = useState<boolean>('loaderVisible', () => route.meta.loaderEnabled === true)
  const showLoader = computed(() => route.meta.loaderEnabled === true && loaderVisible.value)
</script>

<template>
  <MainHeader v-if="!hideHeader" />
  <div
    v-if="showLoader"
    class="fixed inset-0 flex items-center justify-center bg-secondary p-10"
  >
    <UiPlaneLoader />
  </div>
  <main id="main-content">
    <div v-show="!showLoader">
      <PageTopContent />

      <slot />

      <UiBackToTop />
    </div>
  </main>
  <MainFooter />
</template>
